import * as generated from './aasServerClient.generated';

export class AuthWithCookies {
    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        options.credentials = 'same-origin';
        if (options.method !== 'GET') {
            let csrfToken: string = await new generated.Client(process.env.PUBLIC_URL + '/api').getCSRFToken().then(response => {
                return response.csrfToken;
            });
            options.headers = {
                ...options.headers,
                'csrf-token': csrfToken
            }
        }
        return Promise.resolve(options);
    }
}